/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { RecordedCrashDtoFromJSON, RecordedCrashDtoToJSON, } from './RecordedCrashDto';
/**
 * Check if a given object implements the RecordedCrashPageDto interface.
 */
export function instanceOfRecordedCrashPageDto(value) {
    let isInstance = true;
    return isInstance;
}
export function RecordedCrashPageDtoFromJSON(json) {
    return RecordedCrashPageDtoFromJSONTyped(json, false);
}
export function RecordedCrashPageDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(RecordedCrashDtoFromJSON)),
        'nextCursor': !exists(json, 'nextCursor') ? undefined : json['nextCursor'],
    };
}
export function RecordedCrashPageDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(RecordedCrashDtoToJSON)),
        'nextCursor': value.nextCursor,
    };
}
